import { useState } from "react";
import { rankingGroups } from "@/mocks/home";

const trendIcon: Record<string, string> = {
  up: "ri-arrow-up-line text-primary-600",
  down: "ri-arrow-down-line text-secondary-600",
  flat: "ri-subtract-line text-foreground-400",
};

export default function HotRanking() {
  const [activeKey, setActiveKey] = useState(rankingGroups[0].key);
  const group = rankingGroups.find((g) => g.key === activeKey) ?? rankingGroups[0];

  return (
    <section id="ranking" className="border-b border-background-200/70 bg-background-50">
      <div className="px-4 py-12 md:px-10 md:py-16">
        <div className="flex flex-col gap-5 md:flex-row md:items-end md:justify-between">
          <div>
            <div className="flex items-center gap-2 text-xs font-medium uppercase tracking-widest text-primary-600">
              <i className="ri-fire-line text-base"></i>
              HOT RANKING
            </div>
            <h2 className="mt-3 font-heading text-2xl font-semibold text-foreground-950 md:text-3xl">
              热度榜单
            </h2>
            <p className="mt-2 text-sm text-foreground-600">{group.caption}</p>
          </div>

          <div className="flex w-fit items-center gap-1 rounded-full border border-background-300/70 bg-background-100 p-1">
            {rankingGroups.map((g) => (
              <button
                key={g.key}
                type="button"
                onClick={() => setActiveKey(g.key)}
                className={
                  g.key === activeKey
                    ? "cursor-pointer whitespace-nowrap rounded-full bg-primary-500 px-4 py-2 text-sm font-medium text-background-50"
                    : "cursor-pointer whitespace-nowrap rounded-full px-4 py-2 text-sm text-foreground-700 transition-colors hover:text-foreground-950"
                }
              >
                {g.label}
              </button>
            ))}
          </div>
        </div>

        <div className="mt-8 grid grid-cols-1 gap-3 lg:grid-cols-2 lg:gap-x-8">
          {group.items.map((item) => (
            <a
              key={item.id}
              href="#movies"
              className="group flex items-center gap-4 rounded-lg border border-background-200/80 bg-background-50 px-4 py-3.5 transition-colors hover:border-primary-200 hover:bg-primary-50/50"
            >
              <span
                className={
                  item.rank <= 3
                    ? "flex h-9 w-9 shrink-0 items-center justify-center rounded-md bg-primary-500 font-heading text-base font-semibold text-background-50"
                    : "flex h-9 w-9 shrink-0 items-center justify-center rounded-md bg-background-200 font-heading text-base font-semibold text-foreground-700"
                }
              >
                {item.rank}
              </span>

              <div className="min-w-0 flex-1">
                <div className="flex items-center gap-2">
                  <h3 className="truncate font-heading text-sm font-semibold text-foreground-950 md:text-base">
                    {item.title}
                  </h3>
                  <span className="hidden shrink-0 rounded-full bg-accent-100 px-2 py-0.5 text-[11px] font-medium text-accent-900 sm:inline-block">
                    {item.tag}
                  </span>
                </div>
                <p className="mt-1 truncate text-xs text-foreground-600">{item.meta}</p>
              </div>

              <div className="hidden w-32 shrink-0 md:block">
                <div className="h-1.5 w-full overflow-hidden rounded-full bg-background-200">
                  <div
                    className="h-full rounded-full bg-accent-500"
                    style={{ width: `${item.heat}%` }}
                  />
                </div>
                <div className="mt-1.5 text-right text-[11px] text-foreground-500">
                  热度 {item.heat}
                </div>
              </div>

              <i className={`${trendIcon[item.trend]} shrink-0 text-lg`}></i>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}